import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './ui/theme.css';
import { App } from './ui/App';

const container = document.getElementById('app');
if (!container) throw new Error('Missing #app mount point');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
